module.exports = __webpack_public_path__ + "static/media/bank-account.069a9c94.svg";